export default "__VITE_ASSET__TkNV9ddj__"